import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import Index from "./pages/Index";
import About from "./pages/About";
import Flows from "./pages/Flows";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Services from "./pages/Services";
import ServicesTI from "./pages/ServicesTI";
import ServicesRH from "./pages/ServicesRH";
import ServicesQualidade from "./pages/ServicesQualidade";
import ServicesFinanceiro from "./pages/ServicesFinanceiro";
import ConsultoriaIA from "./pages/ConsultoriaIA";
import ConsultoriaFluig from "./pages/ConsultoriaFluig";
import AutomacaoProcessos from "./pages/AutomacaoProcessos";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider 
      attribute="class" 
      defaultTheme="dark" 
      enableSystem={true}
      storageKey="fs-theme"
    >
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter 
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/sobre" element={<About />} />
          <Route path="/flows" element={<Flows />} />
          <Route path="/contato" element={<Contact />} />
          <Route path="/privacidade" element={<Privacy />} />
          <Route path="/termos" element={<Terms />} />
          {/* Services Routes */}
          <Route path="/servicos" element={<Services />} />
          <Route path="/servicos/ti" element={<ServicesTI />} />
          <Route path="/servicos/rh" element={<ServicesRH />} />
          <Route path="/servicos/qualidade" element={<ServicesQualidade />} />
          <Route path="/servicos/financeiro" element={<ServicesFinanceiro />} />
          <Route path="/consultoria-ia" element={<ConsultoriaIA />} />
          {/* Landing Pages */}
          <Route path="/consultoria-fluig" element={<ConsultoriaFluig />} />
          <Route path="/automacao-processos" element={<AutomacaoProcessos />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
